import React from "react";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom"; 
import {
  Button,
  Card, 
  CircularProgress,
  Divider,
  Typography,
  styled,
} from "@mui/material";
import { details } from "../../util/integration";
import { GET_INTEGRATION } from "../../graphql/queries";
import CalendarIntegration from "../business/integeration/calendarIntegration";
const Next2 = styled((props) => <Button variant="contained" {...props} />)({
  color: "white",
  borderRadius: "30px",
  height: "45px",
  background: "background.paper",
  boxShadow: "none",
});
const Integration = (props) => {
  const { integration } = useParams();
  const integrationSlug = integration || "";
  const integrationName = integrationSlug.replace(/_/g, " ");
  const { loading, error, data } = useQuery(GET_INTEGRATION, {
    variables: { integration: integrationName },
    skip: integrationSlug === "google_calendar",
  });

  if (integrationSlug === "google_calendar") {
    return <CalendarIntegration />;
  }
  const integrationData = data?.getIntegration || null;
  const detailEntry =
    details.find((val) => val.name === integrationSlug) ||
    details.find((val) => String(val.name || "").replace(/_/g, " ").toLowerCase() === integrationName.toLowerCase()) ||
    { features: [], requirements: [] };

  if (loading) return <div style={{ width: '100%', height: '600px' }} className="flex align justify"><CircularProgress size={80} /></div>;
  if (error) return <p>Error</p>;

  return (
    <Card
      style={{
        maxWidth: "1000px",
        margin: "30px auto",
        gap: "20px",
        padding: "50px 0",
      }}
      className="flex justify align column"
    >
      {integrationData?.logo ? (
        <img
          component="img"
          alt={integrationData?.name || integrationName}
          style={{ width: "300px" }}
          src={integrationData.logo}
          title={integrationData?.name || integrationName}
        />
      ) : null}
      <Typography gutterBottom variant="h5" component="div">
        {integrationData?.name || integrationName || "Integration"}
      </Typography>
      <div className="flex" style={{ width: "100%" }}>
        <div
          className="flex align column"
          style={{ gap: "10px" }}
        >
          <Typography variant="h5">Features</Typography>{" "}
          <ul style={{ maxWidth: '350px', gap: '10px' }} className="flex column">
            {detailEntry.features.length > 0 ? (
              detailEntry.features.map((val) => (
                <li key={`feature-${val}`}>{val}</li>
              ))
            ) : (
              <li>No feature details available yet.</li>
            )}
          </ul>
        </div>
        <Divider orientation="vertical" style={{ height: "300px" }} />
        <div
          className="flex align column"
          style={{ gap: "10px" }}
        >
          {" "}
          <Typography variant="h5">Requirements</Typography>
          <ul style={{ maxWidth: '350px', gap: '10px' }} className="flex column">
            {detailEntry.requirements.length > 0 ? (
              detailEntry.requirements.map((val) => (
                <li key={`requirement-${val}`}>{val}</li>
              ))
            ) : (
              <li>No requirement details available yet.</li>
            )}
          </ul>
        </div>
      </div>
      <Next2 style={{ padding: "20px" }} disabled> Connect {integrationData?.name || integrationName || "integration"}</Next2>
    </Card>
  );
};

export default Integration;
